import { FC } from 'react';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectIsAnswerRefInRefs } from 'store/player/playerSelectors';
import IAnswer from 'models/Answer';
import { RootState } from 'store';
// Component
import { Button } from 'components/Buttons';

type Props = {
  answer: IAnswer;
  onClick: (answerRef:string) => void;
  disabled?: boolean;
  blured?: boolean;
};

const AnswerButton:FC<Props> = ({
  // Props
  answer, onClick, disabled = false, blured = false
}) => {
  // State
  const isAnswerRefInRefs:boolean = useAppSelector((state:RootState) => selectIsAnswerRefInRefs(state, {
    answerRef: answer.ref
  }));

  return (
    <Button
      className={`
        font-bold 
        ${isAnswerRefInRefs
          ? 'selected-answer-button'
          : 'bg-linear text-[#242324]'
        }
      `}
      onClick={() => onClick(answer.ref)}
      disabled={blured || disabled}
    >
      <span className={blured ? 'blur-sm select-none' : ''}>{answer.title}</span>
    </Button>
  )
}

export default AnswerButton;
